import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import Table from '../../components/Table/Table';
import TableTabs from '../../components/TableTabs/TableTabs';
import Empty from '../../components/Empty/Empty';
import Loader from '../../components/Loader/Loader';
import getVinBlacklistCars from '../../api/vinBlacklist/getVinBlacklistCars';
import useServerTable from './useServerTable';

const tableStyle = { backgroundColor: 'white' };

// ÐÐ°ÑÐ¸Ð½Ñ, ÐºÐ¾ÑÐ¾ÑÑÐµ ÑÐ¶Ðµ Ð±ÑÐ»Ð¸ Ð² Ð±Ð°Ð·Ðµ, ÐºÐ¾Ð³Ð´Ð° Ð¸Ñ VIN Ð¿Ð¾Ð¿Ð°Ð» Ð² ÑÑÑÐ½ÑÐ¹ ÑÐ¿Ð¸ÑÐ¾Ðº. ÐÐ¸ÑÐµÐ³Ð¾ Ð½Ðµ ÑÐ´Ð°Ð»ÑÐµÑÑÑ Ð¸ Ð½Ðµ ÑÐ½Ð¸Ð¼Ð°ÐµÑÑÑ
// Ñ Ð½Ð°Ð»Ð¸ÑÐ¸Ñ: Ð½Ð° Ð½Ð¸Ñ Ð¼Ð¾Ð³ÑÑ Ð±ÑÑÑ ÑÐ´ÐµÐ»ÐºÐ¸. ÐÐ¾Ð²ÑÐµ ÑÐ´ÐµÐ»ÐºÐ¸ Ð¿Ð¾ Ð½Ð¸Ð¼ Ð·Ð°Ð±Ð»Ð¾ÐºÐ¸ÑÐ¾Ð²Ð°Ð½Ñ, Ð¿Ð¾ÑÑÐ¾Ð¼Ñ Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑÑ Ð¿Ð¾Ð»ÐµÐ·Ð½Ð¾ Ð·Ð½Ð°ÑÑ
// Ð·Ð°ÑÐ°Ð½ÐµÐµ, ÐºÐ°ÐºÐ¸Ðµ Ð¼Ð°ÑÐ¸Ð½Ñ Ð² ÑÑÐ¾ÐºÐµ Â«Ð¼ÑÑÑÐ²ÑÐµÂ».
const VinBlacklistCars = () => {
  const columns = useMemo(
    () => [
      { Header: 'VIN', accessor: 'vin', width: '22%' },
      {
        Header: 'ÐÐ°ÑÐ¸Ð½Ð°',
        accessor: 'carId',
        Cell: ({ row }) => (
          <Link to={`/cars/car/${row.original.carId}/main-data`}>
            {[row.original.mark, row.original.model].filter(Boolean).join(' ') || `ID ${row.original.carId}`}
          </Link>
        ),
        width: '22%',
      },
      {
        Header: 'Ð¦ÐµÐ½Ð°, KZT',
        accessor: (row) => (row.price ? Number(row.price).toLocaleString('ru-RU') : 'â'),
        width: '14%',
      },
      { Header: 'Ð Ð½Ð°Ð»Ð¸ÑÐ¸Ð¸', accessor: (row) => row.stock ?? 0, width: '12%' },
      { Header: 'Ð¡Ð´ÐµÐ»ÐºÐ¸', accessor: (row) => row.deals ?? 0, width: '10%' },
      { Header: 'ÐÑÐ¸ÑÐ¸Ð½Ð°', accessor: (row) => row.reason || 'â' },
    ],
    []
  );

  const { table, tableProps, loaded, loading, searching, value, setValue, search } = useServerTable({
    fetcher: getVinBlacklistCars,
    key: 'cars',
    columns,
  });

  return (
    <>
      <TableTabs
        setFilter={search}
        value={value}
        setValue={setValue}
        inputPlaceholder="ÐÑÑÑÑÑÐ¹ Ð¿Ð¾Ð¸ÑÐº Ð¿Ð¾ VIN"
        advancedSearch={false}
        addButton={false}
      />
      <br />
      {!loaded ? (
        <Loader />
      ) : !table.page.length && !loading ? (
        <Empty title={searching ? 'ÐÐ¾ ÑÑÐ¾Ð¼Ñ Ð·Ð°Ð¿ÑÐ¾ÑÑ Ð½Ð¸ÑÐµÐ³Ð¾ Ð½Ðµ Ð½Ð°Ð¹Ð´ÐµÐ½Ð¾.' : 'ÐÐ°ÑÐ¸Ð½ Ð¸Ð· ÑÑÑÐ½Ð¾Ð³Ð¾ ÑÐ¿Ð¸ÑÐºÐ° Ð² Ð±Ð°Ð·Ðµ Ð½ÐµÑ.'} />
      ) : (
        <Table
          {...tableProps}
          all={'Ð¼Ð°ÑÐ¸Ð½'}
          style={tableStyle}
          api={'/api/crm/vin-blacklist/cars'}
          response={'cars'}
          edit={false}
        />
      )}
    </>
  );
};

export default VinBlacklistCars;
